/* Rheinkauf – Produktseite (Paket D), geladen mit defer in sections/main-product.liquid
 *
 * 1. Lieferdatum in der Vertrauenszeile (snippets/rk-produkt-vertrauen.liquid, [data-rk-lieferdatum]).
 *    Gerechnet im Browser, weil Seiten zwischengespeichert werden (Vorbild WSTND snippets/wstnd-trust.liquid).
 *    Werktage = Montag bis Freitag ohne bundesweite Feiertage. Gezählt wird ab heute (deutsche Zeit) bzw. ab
 *    dem nächsten Werktag, wenn heute kein Werktag ist: frühestens + Mindest-, spätestens + Höchst-Werktage
 *    (Theme-Einstellungen, snippets/rk-versand.liquid). Kein Bestellschluss, kein „heute verschickt“ – das ist
 *    für Rheinkauf nicht bestätigt. Darum auch „voraussichtlich“.
 *    Ist die gewählte Variante nicht lieferbar, verschwindet die Zeile (auch nach einem Variantenwechsel – das
 *    Theme meldet ihn über das Formularfeld „id“ und pubsub „variant-change“).
 * 2. „Zuletzt angesehen“ merken – nur mit Einwilligung in Präferenzen („Komfort“ im Rheinkauf-Cookie-Hinweis,
 *    Shopify Customer Privacy API, § 25 TDDDG; Vorbild WSTND). Ohne Einwilligung wird nichts in den
 *    localStorage geschrieben; wird sie entzogen, wird die Liste gelöscht. Gelesen wird die Liste von
 *    assets/recently-viewed-products.js (Schlüssel „recently-viewed“).
 * 3. <rk-reiter>: Reiter ab 750 px, darunter Akkordeon (snippets/rk-produkt-reiterblock.liquid).
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- 1. Lieferdatum */

  var TAGE = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var MONATE = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];

  function schluessel(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  /* Ostersonntag (gregorianischer Kalender, Gauß/Meeus) */
  function ostersonntag(jahr) {
    var a = jahr % 19;
    var b = Math.floor(jahr / 100);
    var c = jahr % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31);
    var tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(jahr, monat - 1, tag, 12);
  }

  /* Bundesweite gesetzliche Feiertage (keine Landesfeiertage) */
  var feiertagCache = {};
  function feiertage(jahr) {
    if (feiertagCache[jahr]) return feiertagCache[jahr];
    var liste = {};
    function fest(monat, tag) { liste[jahr + '-' + monat + '-' + tag] = true; }
    function relativ(tage) {
      var o = ostersonntag(jahr);
      o.setDate(o.getDate() + tage);
      liste[schluessel(o)] = true;
    }
    fest(1, 1);    /* Neujahr */
    fest(5, 1);    /* Tag der Arbeit */
    fest(10, 3);   /* Tag der Deutschen Einheit */
    fest(12, 25);  /* 1. Weihnachtstag */
    fest(12, 26);  /* 2. Weihnachtstag */
    relativ(-2);   /* Karfreitag */
    relativ(1);    /* Ostermontag */
    relativ(39);   /* Christi Himmelfahrt */
    relativ(50);   /* Pfingstmontag */
    feiertagCache[jahr] = liste;
    return liste;
  }

  function istWerktag(d) {
    var t = d.getDay();
    if (t === 0 || t === 6) return false;
    return !feiertage(d.getFullYear())[schluessel(d)];
  }

  function plusWerktage(von, anzahl) {
    var d = new Date(von);
    var gezaehlt = 0;
    while (gezaehlt < anzahl) {
      d.setDate(d.getDate() + 1);
      if (istWerktag(d)) gezaehlt++;
    }
    return d;
  }

  /* Heutiges Datum in Deutschland – nicht in der Zeitzone des Besuchers. Mittags angelegt, damit keine
     Zeitumstellung das Datum verschiebt. */
  function heuteInDeutschland() {
    var jetzt = new Date();
    try {
      var teile = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(jetzt);
      var w = {};
      for (var i = 0; i < teile.length; i++) w[teile[i].type] = parseInt(teile[i].value, 10);
      if (isNaN(w.year) || isNaN(w.month) || isNaN(w.day)) throw new Error('zeit');
      return new Date(w.year, w.month - 1, w.day, 12);
    } catch (e) {
      return new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate(), 12);
    }
  }

  /* „Mi., 8.“ bzw. mit Monat „Fr., 10. Okt.“ */
  function datumText(d, mitMonat) {
    var t = TAGE[d.getDay()] + ', ' + d.getDate() + '.';
    if (mitMonat) t += ' ' + MONATE[d.getMonth()];
    return t;
  }

  /* Ergebnis als Text, z. B. „Mi., 8. – Fr., 10. Okt.“ (exportiert für Tests: window.rkLieferspanne) */
  function lieferspanne(heute, min, max) {
    var basis = new Date(heute);
    while (!istWerktag(basis)) basis.setDate(basis.getDate() + 1);
    var frueh = plusWerktage(basis, min);
    var spaet = plusWerktage(basis, max);
    if (frueh.getTime() === spaet.getTime()) return [datumText(frueh, true)];
    var gleicherMonat = frueh.getMonth() === spaet.getMonth() && frueh.getFullYear() === spaet.getFullYear();
    return [datumText(frueh, !gleicherMonat), datumText(spaet, true)];
  }

  function lieferdatum(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (isNaN(min) || min < 1) return;
    if (isNaN(max) || max < min) max = min;

    var teile = lieferspanne(heuteInDeutschland(), min, max);
    var html = '<strong class="rk-datum">' + teile[0] + '</strong>';
    /* geschütztes Leerzeichen vor dem Strich: sonst beginnt auf dem Handy eine Zeile mit „–“ */
    if (teile.length > 1) html += ' – <strong class="rk-datum">' + teile[1] + '</strong>';
    el.innerHTML = 'Lieferung voraussichtlich ' + html;
    el.setAttribute('data-rk-fertig', '');
  }

  function alleLieferdaten(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-rk-lieferdatum]:not([data-rk-fertig])');
    for (var i = 0; i < liste.length; i++) lieferdatum(liste[i]);
  }

  /* Lieferbar je Variante (JSON aus Liquid, data-varianten) */
  function variantenKarte(box) {
    if (box.__rkKarte) return box.__rkKarte;
    var karte = {};
    try { karte = JSON.parse(box.getAttribute('data-varianten') || '{}') || {}; } catch (e) { karte = {}; }
    box.__rkKarte = karte;
    return karte;
  }

  function lieferbarZeigen(box, lieferbar) {
    var punkt = box.querySelector('[data-rk-liefer-punkt]');
    if (!punkt) return;
    punkt.hidden = !lieferbar;
    if (lieferbar) alleLieferdaten(punkt);
  }

  /* lieferbar: true/false, wenn bekannt (pubsub); sonst aus der Karte über die Varianten-ID */
  function varianteGewechselt(bereich, id, lieferbar) {
    var boxen = (bereich || document).querySelectorAll('[data-rk-vertrauen]');
    for (var i = 0; i < boxen.length; i++) {
      var ok = lieferbar;
      if (typeof ok !== 'boolean') ok = !!(id && variantenKarte(boxen[i])[String(id)] === true);
      lieferbarZeigen(boxen[i], ok);
    }
  }

  /* Das Theme setzt nach jedem Variantenwechsel das Feld „id“ im Produktformular und löst „change“ aus
     (assets/product-variants.js) – leer, wenn es die Kombination nicht gibt. */
  document.addEventListener('change', function (e) {
    var feld = e.target;
    if (!feld || feld.name !== 'id' || !feld.form || !/^product-form-/.test(feld.form.id || '')) return;
    var bereich = feld.closest ? feld.closest('product-info') : null;
    if (!bereich || !bereich.querySelector('[data-rk-vertrauen]')) return;
    varianteGewechselt(bereich, feld.value);
  });

  function pubsubAnmelden() {
    if (typeof window.subscribe !== 'function') return;
    window.subscribe('variant-change', function (ereignis) {
      var d = ereignis && ereignis.data;
      if (!d || !d.variant) return;
      var bereich = null;
      if (d.sectionId) bereich = document.querySelector('product-info[data-section="' + d.sectionId + '"]');
      varianteGewechselt(bereich || document, d.variant.id, !!d.variant.available);
    });
  }

  /* ---------------------------------------------------------- 2. Zuletzt angesehen */

  var ZULETZT_KEY = 'recently-viewed';
  var ZULETZT_MAX = 10;
  var gemerkt = false;

  function handleDerSeite() {
    var el = document.querySelector('product-info[data-main-product][data-product-handle]');
    return el ? el.getAttribute('data-product-handle') : '';
  }

  /* true / false – oder null, solange Shopifys Consent-API nicht geladen ist */
  function praeferenzenErlaubt() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.preferencesProcessingAllowed !== 'function') return null;
    try { return !!cp.preferencesProcessingAllowed(); } catch (e) { return null; }
  }

  function merken() {
    if (gemerkt) return;
    var handle = handleDerSeite();
    if (!handle) return;
    gemerkt = true;
    try {
      var liste = (localStorage.getItem(ZULETZT_KEY) || '').split(',').filter(function (h) {
        return h && h !== 'undefined' && h !== 'false' && h !== handle;
      });
      liste.unshift(handle);
      localStorage.setItem(ZULETZT_KEY, liste.slice(0, ZULETZT_MAX).join(','));
    } catch (e) { /* privater Modus: nichts speichern */ }
  }

  function vergessen() {
    gemerkt = false;
    try { localStorage.removeItem(ZULETZT_KEY); } catch (e) { /* egal */ }
  }

  function entscheiden() {
    var erlaubt = praeferenzenErlaubt();
    if (erlaubt === true) merken();
    else if (erlaubt === false) vergessen();
  }

  /* Shopify meldet jede neue Entscheidung (auch aus dem Rheinkauf-Cookie-Hinweis) mit diesem Ereignis */
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (detail && detail.preferencesAllowed) merken();
    else vergessen();
  });

  function zuletztStarten() {
    if (!handleDerSeite()) return;
    if (praeferenzenErlaubt() !== null) {
      entscheiden();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) entscheiden();
      });
    }
  }

  /* ------------------------------------------------------- 3. Reiter / Akkordeon */

  class RkReiter extends HTMLElement {
    connectedCallback() {
      if (this.__rkFertig) return;
      this.__rkFertig = true;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.rk-reiter__tab'));
      this.akks = Array.prototype.slice.call(this.querySelectorAll('.rk-reiter__akk'));
      this.felder = Array.prototype.slice.call(this.querySelectorAll('.rk-reiter__inhalt'));
      this.mq = window.matchMedia('(min-width: 750px)');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.waehlen(i));
        tab.addEventListener('keydown', (e) => this.taste(e, i));
      });
      this.akks.forEach((akk, i) => {
        akk.addEventListener('click', () => this.umschalten(i));
      });
      const wechsel = () => this.modus();
      if (this.mq.addEventListener) this.mq.addEventListener('change', wechsel);
      else if (this.mq.addListener) this.mq.addListener(wechsel);
      this.modus();
    }

    offen(i) {
      return !!this.felder[i] && this.felder[i].hasAttribute('data-offen');
    }

    setzen(i, auf) {
      const f = this.felder[i];
      if (!f) return;
      if (auf) f.setAttribute('data-offen', '');
      else f.removeAttribute('data-offen');
    }

    /* Reiter: genau einer offen */
    waehlen(index) {
      for (let i = 0; i < this.felder.length; i++) this.setzen(i, i === index);
      this.abgleichen();
    }

    /* Akkordeon: jeder Bereich für sich */
    umschalten(index) {
      this.setzen(index, !this.offen(index));
      this.abgleichen();
    }

    /* Pfeiltasten, Pos1 und Ende wechseln den Reiter (ARIA-Muster „Tabs“) */
    taste(e, i) {
      const n = this.tabs.length;
      let ziel = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') ziel = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ziel = (i - 1 + n) % n;
      else if (e.key === 'Home') ziel = 0;
      else if (e.key === 'End') ziel = n - 1;
      if (ziel === null) return;
      e.preventDefault();
      this.waehlen(ziel);
      this.tabs[ziel].focus();
    }

    /* Rollen je nach Breite: Reiter (tabpanel, beschriftet vom Reiter) oder Akkordeon (region, beschriftet
       vom Knopf in der Überschrift). Beim Wechsel auf Reiter bleibt höchstens der erste offene Bereich offen. */
    modus() {
      const desktop = this.mq.matches;
      if (desktop) {
        let erster = -1;
        for (let i = 0; i < this.felder.length; i++) {
          if (!this.offen(i)) continue;
          if (erster === -1) erster = i;
          else this.setzen(i, false);
        }
      }
      this.felder.forEach((f, k) => {
        if (desktop && this.tabs[k]) {
          f.setAttribute('role', 'tabpanel');
          f.setAttribute('aria-labelledby', this.tabs[k].id);
          f.setAttribute('tabindex', '0');
        } else {
          f.setAttribute('role', 'region');
          if (this.akks[k]) f.setAttribute('aria-labelledby', this.akks[k].id);
          f.removeAttribute('tabindex');
        }
      });
      this.abgleichen();
    }

    abgleichen() {
      let einerOffen = false;
      this.felder.forEach((f, i) => {
        const auf = this.offen(i);
        if (auf) einerOffen = true;
        if (this.tabs[i]) this.tabs[i].setAttribute('aria-selected', auf ? 'true' : 'false');
        if (this.akks[i]) this.akks[i].setAttribute('aria-expanded', auf ? 'true' : 'false');
      });
      /* Tastatur: genau ein Reiter ist per Tab erreichbar – der offene, sonst der erste */
      this.tabs.forEach((tab, t) => {
        const erreichbar = einerOffen ? this.offen(t) : t === 0;
        tab.setAttribute('tabindex', erreichbar ? '0' : '-1');
      });
    }
  }

  if (window.customElements && !window.customElements.get('rk-reiter')) {
    window.customElements.define('rk-reiter', RkReiter);
  }

  /* --------------------------------------------------------------------------- Start */

  function start() {
    alleLieferdaten();
    pubsubAnmelden();
    zuletztStarten();
  }

  window.rkLieferspanne = lieferspanne;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme-Editor: Abschnitt neu geladen */
  document.addEventListener('shopify:section:load', function (e) {
    alleLieferdaten(e.target);
  });
})();
